import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const SessionExpiredModal = ({ open, onRedirect }) => {
  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 2,
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmberIcon color="warning" fontSize="large" />
          <Typography variant="h5" component="span" fontWeight="bold">
            Sessão Expirada
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Sua sessão expirou por motivos de segurança. 
        </Typography>
        <Typography variant="body1">
          Você será redirecionado para fazer login novamente.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onRedirect} 
          variant="contained" 
          color="primary"
          fullWidth
          sx={{ py: 1.5 }}
        >
          Ir para Login
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredModal;